module.exports = __webpack_public_path__ + "img/Image_2.54638c78.png";